module.exports = {"headline":"איך אתם אוהבים את הבוקר שלכם?","desc":"בואו ותגלו יותר על הבוקר שלכם, ואולי תזכו בחוויית בוקר של פעם בחיים המותאמת בדיוק עבורכם. אה כן, ויש לנו גם 20 מכונות Lattissima One לחלק לכם.","button":{"text":"בואו נתחיל"}}


//////////////////
// WEBPACK FOOTER
// ./src/api/data.json
// module id = 92
// module chunks = 0